import { createSlice } from "@reduxjs/toolkit";
import { TemplatesModel } from "types";


const initialState: TemplatesModel[] = [];

const mailTemplatesSlice = createSlice({
  name: 'mailRequests',
  initialState,
  reducers: {
    setMailTemplates: (_state, action: { payload: TemplatesModel[] }) => {
      return action.payload;
    },
  },
});

export const { setMailTemplates } = mailTemplatesSlice.actions;
export default mailTemplatesSlice.reducer;
